import { createFileRoute } from "@tanstack/react-router";
import ChefBrain from "../components/tk/pages/ChefBrain";

const title = "Chef Brain | Menu engineering for F&B leaders | thatKorner";
const description = "Chef Brain places every dish by popularity and contribution margin, tests price changes before you make them, and answers plain-English questions with computed figures.";

export const Route = createFileRoute("/chef-brain")({
  head: () => ({
    meta: [
      { title },
      { name: "description", content: description },
      { property: "og:title", content: title },
      { property: "og:description", content: description },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://www.thatkorner.com/chef-brain" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [{ rel: "canonical", href: "https://www.thatkorner.com/chef-brain" }],
  }),
  component: ChefBrain,
});
